<template>
  <section class="views">
    <headers select="2"></headers>
    <div class="views_content">
      <div class="views_banner">
        <img
          :src="
            require(`@/assets/image/hodgepodge/h5banner_${this.$i18n.locale}.jpg`)
          "
          alt=""
        />
      </div>
      <div class="viewsBoxTab">
        <div class="viewsTab" ref="timeSlide">
          <ul>
            <li
              v-for="(item, index) in gradeColumns"
              :key="index"
              @click="tabBut(index)"
              :class="select === index ? 'select' : ''"
              :ref="`tab${index}Ref`"
            >
              <div>{{ item.name }}</div>
              <div>({{ item.fzhu }})</div>
            </li>
          </ul>
        </div>
      </div>

      <div class="viewsList">
        <transition name="van-slide-left">
          <ul>
            <li
              v-for="(item, index) in pdfList"
              :key="index"
              @click="pdfBut(item)"
            >
              {{ item.name }}
            </li>
            <!-- <div class="backUls_box5">
              <div class="backUls_box5_content">
                <div class="box_title">
                  <img
                    :src="require('@/assets/image/hodgepodge/title_bg.png')"
                    alt=""
                  />
                  <div class="title">
                    {{
                      $t("home.Match_schedule.competition_groups.video_demo")
                    }}
                  </div>
                </div>

                <div class="container">
                  <div
                    class="item"
                    v-for="(item, index) in videoList"
                    :key="item.id"
                  >
                    <div class="item_title">
                      {{ item.title }}
                    </div>
                    <video
                      controls
                      width="100%"
                      style="display: block; margin: auto"
                    >
                      <source :src="item.url" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div> -->
          </ul>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/h_header";
const isIOS = /(iPhone|iPad|iPod|iOS)/.test(navigator.userAgent);
export default {
  name: "views",
  data() {
    return {
      gradeColumns: [
        {
          name: this.$t("home.Match_schedule.competition_groups.group_a_text"),
          fzhu: this.$t("home.Match_schedule.competition_groups.group_a_age"),
        },
        {
          name: this.$t("home.Match_schedule.competition_groups.group_b_text"),
          fzhu: this.$t("home.Match_schedule.competition_groups.group_b_age"),
        },
        {
          name: this.$t("home.Match_schedule.competition_groups.group_c_text"),
          fzhu: this.$t("home.Match_schedule.competition_groups.group_c_age"),
        },
      ],
      pdf: {
        new0: [
          // {
          //   name: this.$t(
          //     "home.Match_schedule.competition_groups.introduction"
          //   ),
          //   url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/ba9d204afe1986b1000a45cabfda0ff7.pdf",
          // },
          {
            name: this.$t("home.Match_schedule.competition_groups.download"),
            url: "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/eda8e3ffd8ce10b372bb49ddd52291fd.pdf",
          },
        ],
        new1: [
          // {
          //   name: this.$t(
          //     "home.Match_schedule.competition_groups.introduction"
          //   ),
          //   url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/ba9d204afe1986b1000a45cabfda0ff7.pdf",
          // },
          {
            name: this.$t("home.Match_schedule.competition_groups.download"),
            url: "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/b85819ebd229ed3fd3f45034e2db6a9e.pdf",
          },
        ],
        new2: [
          // {
          //   name: this.$t(
          //     "home.Match_schedule.competition_groups.introduction"
          //   ),
          //   url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/ba9d204afe1986b1000a45cabfda0ff7.pdf",
          // },
          {
            name: this.$t("home.Match_schedule.competition_groups.download"),
            url: "https://chineserd-audio-1256597606.cos.accelerate.myqcloud.com/readingcontest/id/d3b14003c8f5baa385e7bac9cfc8afed.pdf",
          },
        ],
      },
      videoList: [],
      videoList_0: [
        {
          id: 1,
          title: "《父亲》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/c78b57c83c20e9683111ce45336001f4.mp4",
        },
        {
          id: 2,
          title: "《我爱这土地》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/06da65cf7038f12b7facaafbd87db326.mp4",
        },
        {
          id: 3,
          title: "《水调歌头·明月几时有》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/c8387be6d1b4deb44a7df5a0d40d4333.mp4",
        },
      ],
      videoList_1: [
        {
          id: 4,
          title: "《面朝大海，春暖花开》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/f1f2e8d39d3250a757147cfa1060e0a3.mp4",
        },
        {
          id: 5,
          title: "《再别康桥》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/62da6c1b4290a094043fbef5d6a2666c.mp4",
        },
        {
          id: 6,
          title: "《沁园春·雪》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/fd2d666ac3e7f1e0c2ab72b2963440b3.mp4",
        },
      ],
      videoList_2: [
        {
          id: 7,
          title: "《热爱生命》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/55721cf0d201e25d4c743712b48b2ca6.mp4",
        },
        {
          id: 8,
          title: "《你是人间的四月天》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/d4dfbc7c59d085cebce350721edf4cee.mp4",
        },
        {
          id: 9,
          title: "《将进酒》",
          url: "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-03/33402f8deea06a2fb0b3fe2c2aa9d83e.mp4",
        },
      ],
      pdfList: [],
      select: 0,
    };
  },
  computed: {},
  components: {
    headers,
  },
  // watch: {
  //   select(val){
  //     if(val){
  //       console.log(val);
  //       this.pdfList = [];
  //       this.pdfList = this.pdf[`new${val}`]
  //     }
  //   }
  // },
  created() {
    this.pdfList = this.pdf[`new0`];
    this.videoList = this.videoList_0;
  },
  mounted() {},
  methods: {
    getPdf(e) {
      this.$axios({
        url: e.url,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          this.$toast.clear();
          // this.$toast.success('開始下載');
          // 将文件流转化为 Blob 对象，并创建 a 标签进行下载
          const blob = new Blob([response.data], { type: "application/pdf" });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob); // 创建下载链接
          downloadElement.href = href;
          downloadElement.download = e.name; // 文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 下载
          document.body.removeChild(downloadElement); // 下载完成后移除元素
          window.URL.revokeObjectURL(href); // 释放占用的内存空间
        })
        .catch((error) => {
          this.$toast.clear();
          console.error(error); // 处理异常情况
        });
    },
    pdfBut(e) {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '誦材暫未開放下載',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })
      // return
      if (e.url) {
        let a = document.createElement("a");
        a.href = e.url;
        a.click();
        // if(isIOS){
        // this.getPdf(e);
        // let a = document.createElement('a')
        // a.href = e.url
        // a.click()
        // }else{
        //   let url = 'https://chineserd.cn/h5/html/regulations/index.html?url=' + e.url
        //   let a = document.createElement('a')
        //   a.href = url
        //   a.click()
        // }
      } else {
        this.$dialog
          .alert({
            title: "提示",
            message: "決賽誦材暫未開放下載",
            confirmButtonText: "確認",
          })
          .then(() => {
            // on close
          });
      }
    },
    tabBut(e) {
      this.select = e;
      this.pdfList = this.pdf[`new${e}`];
      this.videoList = this[`videoList_${e}`];
      // 触发滑动方法
      this.scrollLeftTo(e);
    },
    // 滑动
    scrollLeftTo(name) {
      const ref = `tab${name}Ref`;
      const nav = this.$refs.timeSlide;
      console.log("额:", this.$refs.timeSlide.offsetWidth);
      const title = this.$refs[ref][0];
      // 计算位移偏差
      const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
      nav.scrollLeft = to;
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: linear-gradient(225deg, #ff8310 0%, #fe840f 100%);
  .views_content::-webkit-scrollbar {
    display: none;
  }
  .views_content {
    width: 100%;
    height: calc(100% - 0.92rem);
    overflow: scroll;

    .views_banner {
      width: 100%;
      display: grid;

      img {
        width: 100%;
      }
    }

    .viewsTab::-webkit-scrollbar {
      display: none;
    }

    .viewsBoxTab {
      width: 100%;
    }

    .viewsTab {
      width: 100%;
      padding: 0.16rem 0;
      box-sizing: border-box;
      overflow-y: scroll;
      margin-top: -6%;

      ul {
        width: 100%;
        height: 1.28rem;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;

        li {
          width: 3.14rem;
          height: 100%;
          display: flex;
          align-content: center;
          align-items: center;
          flex-wrap: wrap;
          font-family: PingFang SC-Semibold, PingFang SC;
          line-height: 0.38rem;
          flex: 0 0 auto;
          background: #d34a00;

          div {
            width: 100%;
          }

          div:nth-child(1) {
            font-size: 0.28rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 0.33rem;
          }

          div:nth-child(2) {
            font-size: 0.22rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 0.26rem;
          }
        }

        .select {
          font-size: 0.32rem;
          font-weight: 600;
          color: #903300;
          padding: 0.16rem 0;
          background: url("~@/assets/image/hodgepodge/tabbuttom.png") no-repeat;
          background-size: 100% 100%;

          div:nth-child(1) {
            font-size: 0.32rem !important;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600 !important;
            color: #903300;
            line-height: 0.38rem !important;
          }

          div:nth-child(2) {
            font-size: 0.26rem !important;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600 !important;
            color: #903300;
            line-height: 0.3rem !important;
          }
        }
      }
    }

    .viewsList {
      width: 100%;
      margin-top: 0.32rem;

      padding: 0.32rem;
      box-sizing: border-box;

      ul {
        width: 100%;

        li {
          width: 100%;
          height: 2.48rem;
          background: #fff8de;
          box-shadow: 0px 0px 0.08rem 0px rgba(126, 56, 0, 0.26);
          border: 0.08rem solid #fff0e1;
          border-radius: 0.32rem;
          margin-bottom: 0.32rem;

          font-size: 0.48rem;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff782f;
          line-height: 0.56rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

.backUls_box5 {
  width: 100%;
  // padding: 0.32rem;
  padding-top: 1rem;
  box-sizing: border-box;

  .backUls_box5_content {
    width: 100%;
    background-size: 100%;
    padding: 0.25rem;
    padding-top: 0rem;
    box-sizing: border-box;
    border-image-source: url("~@/assets/image/hodgepodge/back3.png");
    border-image-slice: 84 10 10 10;
    border-image-width: 0.6rem 0.12rem 0.12rem 0.12rem;
    border-width: 0.12rem;

    .ulstitle {
      width: 6.0228rem;
      height: 0.43rem;
      margin: auto;
      img {
        width: 100%;
        margin-top: -0.85rem;
      }
    }
    /*  */
    .container {
      width: 100%;
      min-height: 3rem;
      background: #ffffff;
      padding: 0.32rem 0.24rem;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0rem 0.08rem 0.12rem 0rem rgba(0, 0, 0, 0.05);
      border-radius: 0.16rem;
      position: relative;
      .item {
        margin-bottom: 0.25rem;
      }
      .item:last-child {
        margin-bottom: 0;
      }
      .item_title {
        padding: 0.14rem 0.66rem;
        box-sizing: border-box;
        background: #ff9003;
        box-shadow: 0rem 0rem 0.14rem 0rem rgba(249, 118, 47, 0.3);
        border-radius: 0.62rem;
        border: 0.04rem solid #ffffff;
        font-size: 0.32rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        display: inline-block;
        margin-bottom: 0.25rem;
      }
    }
  }
}

.box_title {
  width: 6.0228rem;
  height: 0.43rem;
  box-sizing: border-box;
  margin: auto;
  position: relative;
  img {
    // height: 118.8px;
    // margin-top: -6.1%;
    // object-fit: none;
    width: 100%;
    margin-top: -0.85rem;
  }

  .title {
    margin-left: -3%;
    width: 62%;
    position: absolute;
    top: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.4rem;
    // white-space: nowrap;
    font-weight: bold;
    color: #fff;
    // text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    text-shadow: -1px -1px 0 #ff782f, 1px -1px 0 #ff782f, -1px 1px 0 #ff782f,
      1px 1px 0 #ff782f;
  }
}
</style>
